import { useFixtureService, useGetFixture } from "~pages/Fixtures/hooks";
import type { EditFixtureForm } from "~pages/Fixtures/types";
import { getEntrantsSubmitData, getFixtureSubmitData } from "../utilities";

export const useEditFixtureFormSubmit = () => {
  const { data: fixtureData } = useGetFixture();
  const { updateFixtureAdvanced } = useFixtureService();

  return (values: EditFixtureForm) =>
    updateFixtureAdvanced({
      fixture: getFixtureSubmitData(values),
      ...getEntrantsSubmitData(values),
      oldSeriesCode: fixtureData?.formData.seriesCode?.value,
    });
};
